import { useTranslation } from 'react-i18next';
import {
  Typography as MuiTypography,
  Divider as MuiDivider,
  Box as MuiBox,
  Button as MuiButton,
} from '@mui/material';
import styled from 'styled-components';
import LoadingPage from 'components/LoadingPage';
import { format, parseISO } from 'date-fns';
import { JamIcon } from 'components/ui';
import { getQuestionnaireResponseEndDate } from '.';
import { dateFnsLocales } from 'lib/utils/getDateFnsLocales';
import { getMainComponent } from 'lib/utils/metricComponents';

const Footer = (props) => {
  const {
    selected,
    isQuestionnaire,
    questionnaireAnswers,
    metricDefinitionId,
    loading,
    onSeeAnswers,
  } = props;
  const { t, i18n } = useTranslation();
  const locale = dateFnsLocales[i18n.language];

  const getFooterTitle = () => {
    return selected?.aggregationPeriod !== 'DAILY'
      ? t('Questionnaires answered between {{startDate}} and {{endDate}}', {
          startDate: selected?.date
            ? `${format(parseISO(selected?.date), 'PPP', {
                locale,
              })}`
            : '-',
          endDate:
            selected?.aggregationPeriod && selected?.date
              ? `${format(
                  parseISO(
                    getQuestionnaireResponseEndDate(
                      selected?.aggregationPeriod,
                      selected?.date
                    )
                  ),
                  'PPP',
                  {
                    locale,
                  }
                )}`
              : '-',
        })
      : t('Questionnaires answered in {{date}}', {
          date: selected?.date
            ? `${format(parseISO(selected?.date), 'PPP', {
                locale,
              })}`
            : '-',
        });
  };

  const getFooterTitleWithoutSelection = () =>
    t('Questionnaires answered between {{startDate}} and {{endDate}}', {
      startDate: selected?.startDateTime
        ? `${format(parseISO(selected?.startDateTime), 'PPP', {
            locale,
          })}`
        : '-',
      endDate: selected.endDateTime
        ? `${format(parseISO(selected.endDateTime), 'PPP', {
            locale,
          })}`
        : '-',
    });

  return (
    <>
      {isQuestionnaire && questionnaireAnswers && (
        <>
          <MuiTypography
            style={{ marginTop: '30px' }}
            variant="h5"
            color="textPrimary"
          >
            {selected?.date
              ? getFooterTitle() + ':'
              : getFooterTitleWithoutSelection() + ':'}
          </MuiTypography>
          {loading ? (
            <LoadingPage style={{ height: 150, flex: 1 }} />
          ) : (
            questionnaireAnswers.map((questionnaireAnswer) => {
              return (
                <SWrapper key={questionnaireAnswer?.id}>
                  {questionnaireAnswer?.id ? (
                    <MuiBox display="flex" alignItems="center">
                      <MuiBox mt="10px" display="flex" flexDirection="column">
                        <MuiTypography variant="h4">
                          {questionnaireAnswer?.mainScoreMetric
                            ?.metricDefinitionId === metricDefinitionId
                            ? getMainComponent(questionnaireAnswer?.mainScoreMetric?.components)
                                ?.quantityValue?.value || '-'
                            : getMainComponent(
                                questionnaireAnswer?.subScoreMetrics?.find(
                                  (subscore) =>
                                    subscore?.metricDefinitionId ===
                                    metricDefinitionId
                                )?.components
                              )?.quantityValue?.value || '-'}
                        </MuiTypography>
                        <MuiTypography variant="h5">{t('Score')}</MuiTypography>
                      </MuiBox>

                      <MuiDivider
                        style={{ margin: '5px 20px' }}
                        flexItem
                        orientation="vertical"
                      />
                      <MuiBox>
                        <MuiTypography variant="body1">
                          {format(
                            parseISO(
                              questionnaireAnswer?.mainScoreMetric?.createdAt
                            ),
                            'PPPp',
                            {
                              locale,
                            }
                          )}
                        </MuiTypography>
                      </MuiBox>
                      <MuiButton
                        style={{
                          marginLeft: 'auto',
                          justifySelf: 'flex-end',
                          borderRadius: '25px',
                          padding: '4px 12px',
                        }}
                        startIcon={
                          <JamIcon size={20} icon="document" color="inherit" />
                        }
                        onClick={() => onSeeAnswers(questionnaireAnswer, metricDefinitionId)}
                      >
                        {t('See answers')}
                      </MuiButton>
                    </MuiBox>
                  ) : (
                    <SMuiTypography variant="subtitle1" color="textSecondary">
                      {t('Select a value to display')}
                    </SMuiTypography>
                  )}
                </SWrapper>
              );
            })
          )}
        </>
      )}
    </>
  );
};

const SWrapper = styled.div`
  margin: 30px 0 30px;
  flex-direction: column;
  width: 100%;
  display: flex;
`;

const SMuiTypography = styled(MuiTypography)`
  margin-top: 5px;
`;

export default Footer;
